import {
  SEARCH_DID_URL,
  COUNT_DID_URL,
  DELETE_DID_URL,
  DELETE_DIDS_URL,
  SEARCH_DID_HISTORY_URL,
  COUNT_DID_HISTORY_URL,
  GENERATE_VIRTUAL_DID_URL,
  ALL_SENT_HISTORY_URL,
  ALL_CLICK_HISTORY_URL,
  FARM_LIST_DEVICE_URL,
  COUNT_DEVICE_URL,
  LIST_DEVICE_URL,
  SEND_MESSAGE_DEVICE_URL,
  UPGRADE_DEVICE_URL,
  UPDATE_MONITORING_URL,
  CHANGE_NUMBER_URL,
  DELETE_CHANGE_NUMBER_URL,
  PING_URL,
  CLICK_HISTORY_URL,
  SENT_HISTORY_URL,
  STATUS_HISTORY_URL,
  ALL_STATUS_HISTORY_URL,
  CREATE_WORKER_URL,
  CREATE_FARM_URL,
  ASSIGN_WORKER_URL,
  LIST_LOGIN_URL,
  TEST_LOGIN_URL,
  DELETE_DEVICE_URL,
  LOAD_DID_GROUPS,
  TEXTBACK_DIDs_SEARCH,
  TEXTBACK_DIDs_COUNT,
  TEXTBACK_DIDs_DELETEs,
  TEXTBACK_DIDs_DELETE,
  CLEAR_CACHE_URL,
  SERVICE_CHECK_HISTORY_URL,
  LIST_DEVICE_BY_RANGES_URL,
  NUMBER_POOL_VENDORS,
  IMPORT_NUMBER_POOL_URL,
  NUMBER_POOL_SEARCH,
  COLLECT_LOGS_URL,
  NUMBER_POOL_URL,
  LINK_10DLC_STATUS_URL,
  EXPORT_DID_URL,
  DELETE_DIDS_BY_LIST,
} from 'consts/api';
import { convertDateByFormat } from 'helpers/date-time';
import { AppLoginRequest, ListAppLoginRequest, DeleteDeviceRequest } from 'interfaces/requests';
import services from 'services';
import querystring from 'query-string';
import userServices from './userServices';

const DID_MIGRATION_URL = '/api/v1/did-migration';
const formatDate = 'YYYYMMDD HH';
class DidServices {
  searchDids(filters = {}) {
    return services.post(SEARCH_DID_URL, filters);
  }

  countDids(filters = {}) {
    return services.post(COUNT_DID_URL, filters);
  }

  deleteDid(phone = '') {
    return services.post(DELETE_DID_URL, { phone });
  }

  deleteDids(body) {
    return services.post(DELETE_DIDS_URL, body);
  }

  searchDidHistory(filters = {}) {
    return services.post(SEARCH_DID_HISTORY_URL, filters);
  }

  countDidHistory(filters = {}) {
    return services.post(COUNT_DID_HISTORY_URL, filters);
  }

  generateVirtualDid({ areaCode, countryCode, quantity }) {
    return services.post(GENERATE_VIRTUAL_DID_URL, {
      areaCode,
      countryCode,
      quantity,
    });
  }

  getListDevice(filters = {}) {
    return services.post(LIST_DEVICE_URL, filters);
  }

  countListDevice(filters = {}) {
    return services.post(COUNT_DEVICE_URL, filters);
  }

  getListFarmDevice() {
    return services.get(FARM_LIST_DEVICE_URL);
  }

  getAllClickHistory(filters = {}) {
    return services.post(ALL_CLICK_HISTORY_URL, filters);
  }

  getAllSentHistory(filters = {}, { from = '', to = '' }) {
    const correctFrom = convertDateByFormat(from, formatDate);
    const correctTo = convertDateByFormat(to, formatDate);
    return services.post(
      `${ALL_SENT_HISTORY_URL}?from=${encodeURIComponent(correctFrom)}&to=${encodeURIComponent(
        correctTo,
      )}`,
      filters,
    );
  }

  getAllStatusHistory(filters = {}, { from = '', to = '' }) {
    const correctFrom = convertDateByFormat(from, formatDate);
    const correctTo = convertDateByFormat(to, formatDate);
    return services.post(
      `${ALL_STATUS_HISTORY_URL}?from=${encodeURIComponent(correctFrom)}&to=${encodeURIComponent(
        correctTo,
      )}`,
      filters,
    );
  }

  getNumberPoolVendors() {
    return services.get(`${NUMBER_POOL_VENDORS}`);
  }

  importNumberPool(body) {
    return services.post(`${IMPORT_NUMBER_POOL_URL}`, body);
  }

  searchNumberPool(body) {
    return services.post(`${NUMBER_POOL_SEARCH}`, body);
  }

  sendMessage(body = {}) {
    return services.post(SEND_MESSAGE_DEVICE_URL, body);
  }

  upgradeDevice(code) {
    return services.post(UPGRADE_DEVICE_URL, { codes: [code] });
  }

  updateMonitoringDevice(body = { code: '', zipCode: '', note: '', rackName: '', sendSpeed: 1 }) {
    return services.post(UPDATE_MONITORING_URL, body);
  }

  updateMappingDID(body = { code: '', inMapping: false }) {
    return services.post(UPDATE_MONITORING_URL, body);
  }

  updateSkipServiceCheck(body = { code: '', skipServiceCheck: false }) {
    return services.post(UPDATE_MONITORING_URL, body);
  }

  changeNumber(code = '') {
    return services.post(`${CHANGE_NUMBER_URL}?code=${code}`);
  }

  deleteNumber(code = '') {
    return services.delete(`${DELETE_CHANGE_NUMBER_URL}?code=${code}`);
  }

  wakeUp(code = '') {
    return services.post(PING_URL, { code });
  }

  clearCache(code = '') {
    return services.post(CLEAR_CACHE_URL, { code });
  }

  collectLogs(code = '') {
    return services.post(COLLECT_LOGS_URL, { code });
  }

  getClickHistory(code) {
    return services.post(CLICK_HISTORY_URL, { code });
  }

  getSentHistory(code, { from, to }) {
    const correctFrom = convertDateByFormat(from, formatDate);
    const correctTo = convertDateByFormat(to, formatDate);
    return services.post(`${SENT_HISTORY_URL}?from=${correctFrom}&to=${correctTo}`, { code });
  }

  getStatusHistory(code) {
    return services.post(STATUS_HISTORY_URL, { code });
  }

  createWorker(body = {}) {
    return services.post(CREATE_WORKER_URL, body);
  }

  assignWorker(body = {}) {
    return services.post(ASSIGN_WORKER_URL, body);
  }

  createFarm(body = {}) {
    return services.post(CREATE_FARM_URL, body);
  }

  getListAppLogin(body = new ListAppLoginRequest()) {
    return services.post(LIST_LOGIN_URL, body);
  }

  testAppLogin(body = new AppLoginRequest()) {
    return services.post(TEST_LOGIN_URL, body);
  }

  deleteDevice(body = new DeleteDeviceRequest()) {
    return services.post(DELETE_DEVICE_URL, body);
  }

  loadDidGroups(email = '', routeId = '') {
    return services.get(`${LOAD_DID_GROUPS}?email=${email}&routeId=${routeId}`);
  }

  //* For worker
  textbackSearchDids(filters = {}) {
    return services.post(TEXTBACK_DIDs_SEARCH, filters);
  }

  textbackCountDids(filters = {}) {
    return services.post(TEXTBACK_DIDs_COUNT, filters);
  }

  textbackDeleteDids(
    body = {
      created: '',
      nextCharge: '',
      phone: '',
      type: '',
      username: '',
    },
  ) {
    return services.post(TEXTBACK_DIDs_DELETEs, body);
  }

  textbackDeleteDid(phone = '') {
    return services.post(TEXTBACK_DIDs_DELETE, { phone });
  }

  getAllServiceCheckHistory(filters = {}, { from = '', to = '' }) {
    const correctFrom = convertDateByFormat(from, formatDate);
    const correctTo = convertDateByFormat(to, formatDate);
    return services.post(
      `${SERVICE_CHECK_HISTORY_URL}?from=${encodeURIComponent(correctFrom)}&to=${encodeURIComponent(
        correctTo,
      )}`,
      filters,
    );
  }

  getListFarmDeviceByRange(lat1, lat2, long1, long2) {
    return services.get(
      `${LIST_DEVICE_BY_RANGES_URL}?lat1=${lat1}&lat2=${lat2}&long1=${long1}&long2=${long2}`,
    );
  }

  getDetailNumber(idNumber) {
    return services.get(`${NUMBER_POOL_URL}/${idNumber}`);
  }

  addNumberToPool(
    body = {
      number: '',
      country: '',
      vendorId: '',
      type: '',
    },
  ) {
    return services.post(`${NUMBER_POOL_URL}/add`, body);
  }

  updateNumber(
    idNumber,
    body = {
      number: '',
      country: '',
      vendorId: '',
      type: '',
    },
  ) {
    return services.put(`${NUMBER_POOL_URL}/${idNumber}`, body);
  }

  purchaseNumbersTFN(
    body = {
      vendorId: '',
      amount: 0,
    },
  ) {
    return services.post(`${NUMBER_POOL_URL}/purchase-tfn`, body);
  }

  link10dlcStatus(
    body = {
      phone: '+12312372343',
      vendor: 'victoryc',
      linkStatus: 'COMPLETED',
    },
  ) {
    return services.post(LINK_10DLC_STATUS_URL, body);
  }

  exportDIDs(filters) {
    delete filters.pageIndex;
    delete filters.pageSize;

    return services.post(EXPORT_DID_URL, filters, { responseType: 'blob' });
  }

  downloadDIDsByTaskId(taskId) {
    window.open(
      `/api/v1/did/download-export-dids?taskId=${taskId}&sessionId=${
        userServices.getJWTAuth()?.jwt
      }`,
    );
  }

  deleteDidsByList(dids) {
    return services.post(DELETE_DIDS_BY_LIST, dids);
  }

  migrationDID() {
    return {
      submitRequest: (
        body = {
          amount: '',
          sourceGroupId: '',
          destGroupId: '',
          reason: '',
          deduceCredit: false,
        },
      ) => {
        return services.post(`${DID_MIGRATION_URL}/submitRequest`, body);
      },
      approve: (requestId) => {
        return services.put(`${DID_MIGRATION_URL}/approve?requestId=${requestId}`);
      },
      reject: (requestId) => {
        return services.put(`${DID_MIGRATION_URL}/reject?requestId=${requestId}`);
      },
      release: (requestId) => {
        return services.put(`${DID_MIGRATION_URL}/release?requestId=${requestId}`);
      },
      rollback: (requestId) => {
        return services.put(`${DID_MIGRATION_URL}/rollback?requestId=${requestId}`);
      },
      lookup: (
        body = {
          groupName: '',
          adminEmail: '',
          status: '',
          pageSize: 25,
          pageNumber: 1,
        },
      ) => {
        return services.get(`${DID_MIGRATION_URL}/lookup?${querystring.stringify(body)}`);
      },
      downloadMigrateDID: (requestId) => {
        return services.post(`${DID_MIGRATION_URL}/download-migrated-dids?requestId=${requestId}`);
      },
    };
  }
}

export default new DidServices();
